import { Entity, Field } from "typegraph";

import Badge from "./Badge";
import { Entry, PreTestEntry } from "./Entry";
import ProgramProgress from "./ProgramProgress";

@Entity({one: "program", many: "programs"})
export default class Program {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public description: string;

	@Field({entity: ProgramProgress})
	public progress: ProgramProgress[];

	@Field({entity: PreTestEntry})
	public preTest?: PreTestEntry;

	@Field({entity: Entry})
	public postTest?: Entry;

	@Field({entity: Badge})
	public badges?: Badge[];

}



// WEBPACK FOOTER //
// ./src/panels/program/entities/Program.ts